import qs from 'qs';
import store from '../store';

/**
 * 历史记录API
 */
export default {
    async getHistoryList () {
        let token = store.state.account.token;
        const API = '/call-platform/session/listSessions';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async getChatHistory (sessionId) {
        let token = store.state.account.token;
        const API = `/call-platform/conversation/getList?sessionId=${sessionId}`;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async getNewSessionId () {
        let token = store.state.account.token;
        // transGpt是demo测试版本，不走公服接口
        let apiPre = '/call-platform';
        if (location.hash.indexOf('transGpt') !== -1) {
            apiPre = '/only-mem-server';
        }
        const API = apiPre + '/session/applySessionId';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let json = await resp.json();
        return json;
    },
    async saveSession (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/session/saveSession';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async saveOneContext (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/conversation/add';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async sendFeedback (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/conversation/answerFeedback';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let query = `?likeOrNot=${payload.likeOrNot}&questionId=${payload.questionId}`;
        let resp = await fetch(API + query, { method: 'POST', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async deleteSession (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/session/deleteSession';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let query = `?sessionId=${payload.sessionId}`;
        let resp = await fetch(API + query, { method: 'POST', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async editTitle (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/session/updateSessionTitle';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let query = `?sessionId=${payload.sessionId}&title=${payload.title}`;
        let resp = await fetch(API + query, { method: 'POST', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async stopAnswer (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/conversation/stopAnswer';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let query = `?sessionId=${payload.sessionId}`;
        let resp = await fetch(API + query, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    async starSession (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/session/collectSession';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let query = `?sessionId=${payload.sessionId}&collected=${payload.collected}`;
        let resp = await fetch(API + query, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    async getQaRecord (sessionId) {
        let token = store.state.account.token;
        const API = '/call-platform/llmQaRecord/get?isAsc=true&sessionId=' + sessionId;
        let headers = { 'Content-Type': 'x-www-form-urlencoded', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    async getQaRecordPage (payload) {
        let token = store.state.account.token;
        let query = qs.stringify(payload);
        const API = '/call-platform/llmQaRecord/page?' + query;
        let headers = { 'Content-Type': 'x-www-form-urlencoded', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    /**
     * 查询业务类型
     */
    async getBizTypes () {
        let token = store.state.account.token;
        const API = '/call-platform/llmQaRecord/bizTypes';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    }
};
